import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Result, Guard, Entity, UniqueEntityID } from '@digibricks/core';
export var SecurityOptionType;

(function (SecurityOptionType) {
  SecurityOptionType["outOfFocusTab"] = "c10d7535-55eb-48f1-8ca5-cef8d9e60ffe";
  SecurityOptionType["copyPaste"] = "b66d1d9e-20bd-4093-bc48-ace2cf9281ba";
})(SecurityOptionType || (SecurityOptionType = {}));

export var SecurityOption = /*#__PURE__*/function (_Entity) {
  _inherits(SecurityOption, _Entity);

  var _super = _createSuper(SecurityOption);

  function SecurityOption() {
    _classCallCheck(this, SecurityOption);

    return _super.apply(this, arguments);
  }

  _createClass(SecurityOption, [{
    key: "key",
    get: function get() {
      return this.props.key;
    }
  }, {
    key: "translation",
    get: function get() {
      return this.props.translation;
    }
  }], [{
    key: "create",
    value: function create(props, id) {
      var guardCollection = [{
        argument: props.key,
        argumentName: 'Key'
      }, {
        argument: props.translation,
        argumentName: 'Translation'
      }];
      var guardResult = Guard.againstNullOrUndefinedBulk(guardCollection);

      if (!guardResult.succeeded) {
        return Result.fail(guardResult.message);
      }

      return Result.ok(new SecurityOption(props, new UniqueEntityID(id)));
    }
  }, {
    key: "isDefaultSecurityOption",
    value: function isDefaultSecurityOption(securityOption) {
      return this.defaultSecurityOptionsKeys.includes(securityOption.key);
    }
  }]);

  return SecurityOption;
}(Entity);

_defineProperty(SecurityOption, "defaultSecurityOptionsKeys", [SecurityOptionType.copyPaste // Add more default security options here
]);